import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fc9cea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "设置", -1))
const _hoisted_5 = { class: "sys-menu" }
const _hoisted_6 = { class: "right" }

import Top from "@/components/Top.vue";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const list = ref([
  { text: "个人信息", url: "/index/system/user", active: true },
  { text: "修改密码", url: "/index/system/pwd", active: false },
]);

const handleClick = (item: any) => {
  list.value.forEach((item) => {
    item.active = false;
  });
  item.active = true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 20 }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(item.active ? 'active' : '')
              }, [
                _createVNode(_component_router_link, {
                  to: item.url,
                  class: "block",
                  onClick: ($event: any) => (handleClick(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.text), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"])
              ], 2))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Top),
      _createVNode(_component_router_view, { class: "main-view" }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ], 1024))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})